import { useParams } from "react-router-dom";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { OldGrid } from "src/components/atoms/OldGrid/OldGrid";
import StatsTable from "../../compounds/StatsTable/StatsTable";
import Styles from "./SeasonStatsPage.module.scss";
import { Title } from "src/components/atoms/Title/Title";
import { mergeSeasonStatsForGrid } from "./stats-columns/common-columns";
import { useGetTeamStatsByIDQuery, useGetTeamPlayersByIDQuery } from "src/state/modules/api";
import PageLoader1 from "src/components/atoms/PageLoader/PageLoader";

export default function SeasonStatsPage() {
  const { id } = useParams();
  const teamID = id ?? "";
  const { data: stats, isLoading: statsLoading } = useGetTeamStatsByIDQuery(teamID);
  const { data: players, isLoading: playersLoading } = useGetTeamPlayersByIDQuery(teamID);

  if (statsLoading || playersLoading) return <PageLoader1 />;

  function getGrid() {
    if (players && stats) return mergeSeasonStatsForGrid(players, stats.stats_data.players);
    return [];
  }

  return (
    <OldGrid className={Styles.statsPageContainer}>
      <div className={Styles["top-grid"]}>
        <Title text={"Stats"} className={Styles.title}></Title>
      </div>
      <StatsTable grid={getGrid()} totals={stats?.stats_data?.stats} />
    </OldGrid>
  );
}
